<script>
import creditCards from './creditCards.json'
export let data

let usePoint = 'no_use'
let pointNum = 0

$: pointNum = (() =>{
    switch (usePoint) {
        case 'no_use':
            return 0
        case 'part':
            if (pointNum) {
                return pointNum > data.amount ? data.amount : pointNum
            } else {
                return 0
            }
        case 'all':
            return data.amount
    }
})()

$: pointNumLabel = pointNum ? pointNum : '0'

$: fee = () => {
    switch (usePoint) {
        case 'no_use':
            return (data.amount * data.fee) / 100
        case 'part':
            return Math.floor((data.amount - pointNum) * data.fee / 100)
        default:
            return 0
    }
}

$: paymentAmount = () => {
    switch (usePoint) {
        case 'no_use':
        case 'part':
            return data.amount - pointNum + fee()
        default:
            return 0
    }
}

$: isFullAmountPayWithPoints = (data.amount - pointNum === 0);
</script>

<div class="mt-6">
    <p class="text-sm font-bold text-site-sub-black">ポイントを利用</p>
    <div class="flex justify-between items-center mt-4">
        <div>
            <p class="text-sm text-site-sub-black">利用可能ポイント</p>
            <p class="text-sm text-site-purple-2">{data.point_num} pt</p>
        </div>
        <a href="/s/mypages/points/charges/new" class="py-2 px-3 text-black no-underline rounded-md border border-site-gray-2">+ チャージ</a>
    </div>
    <div class="field flex flex-col justify-center items-start !mt-4">
        <div class="!mt-4 ui radio checkbox">
            <input id="use_point_no_use" bind:group={usePoint} type="radio" name="use_point" value="no_use" checked>
            <label for="use_point_no_use">ポイントを利用しない</label>
        </div>
        <div class="!mt-4 ui radio checkbox">
            <input id="use_point_all" bind:group={usePoint} type="radio" name="use_point" value="all" disabled={data.point_num < data.amount}>
            <label for="use_point_all">全額ポイントで支払う</label>
        </div>
        <div class="!mt-4 ui radio checkbox">
            <input id="use_point_part" bind:group={usePoint} type="radio" name="use_point" value="part" disabled={data.point_num <= 0}>
            <label for="use_point_part">一部ポイントで支払う</label>
        </div>
    </div>
    <div class="field" hidden={usePoint !== 'part'}>
        <input bind:value={pointNum} type="number" name="point_num" min="0" max="{data.point_num}" placeholder="使用するポイントを入力してください" required>
    </div>
    <hr class="mt-6 w-full h-[1px] bg-site-gray-1">
    <h3 class="mt-6 text-sm font-bold text-black">お支払い</h3>
    <div class="flex justify-between items-center mt-4">
        <p class="text-xs text-site-sub-black">リクエストに必要なポイント</p>
        <p class="text-sm text-site-sub-black">{data.amount} pt</p>
    </div>
    {#if usePoint === 'part' || usePoint === 'all'}
        <div class="flex justify-between items-center mt-1">
            <p class="text-xs text-site-sub-black">使用するポイント</p>
            <p class="text-sm text-site-red-2">- {pointNumLabel} pt</p>
        </div>
    {/if}
    {#if usePoint === 'no_use' || usePoint === 'part'}
        <div class="flex justify-between items-center mt-1">
            <p class="text-xs text-site-sub-black">購入するポイント</p>
            <p class="text-sm text-site-sub-black"> {data.amount - pointNum} pt</p>
        </div>
        <div class="flex justify-between items-center mt-1">
            <p class="text-xs text-site-sub-black">消費税＋手数料</p>
            <p class="text-sm text-site-sub-black">¥{fee()}</p>
        </div>
    {/if}
    <div class="flex justify-between items-center mt-4">
        <p class="text-sm text-site-black">お支払い金額</p>
        <p class="text-sm text-black">¥{paymentAmount()}</p>
    </div>
    <hr class="mt-6 w-full h-[1px] bg-site-gray-1">
    <h3 class="mt-6 text-sm font-bold text-black">ご利用可能なカード</h3>
    <div class="grid grid-cols-6 gap-2 items-center">
        {#each creditCards as card}
            <img src={card.imgPath} alt={card.alt}>
        {/each}
    </div>
    {#if isFullAmountPayWithPoints}
        <button class="block mx-auto mt-4 btn btn-purple" data-turbo-submits-with="送信中..." data-turbo-confirm=" ポイントを使用してリクエストします。よろしいですか？">ポイントでリクエストする</button>
    {:else}
        <button class="block mx-auto mt-4 btn btn-purple" data-turbo-submits-with="送信中...">カード情報の入力に進む</button>
    {/if}
</div>
